import { reactive } from 'vue'

const LEGACY_COLOR_TO_VARIANT = {
  success: 'success',
  error: 'error',
  alert: 'warning',
  warning: 'warning',
  info: 'info',
  default: 'neutral',
  neutral: 'neutral',
  danger: 'error',
}

function resolveVariant(info) {
  const legacyColor = info?.snackbarColor || info?.type
  if (legacyColor && LEGACY_COLOR_TO_VARIANT[legacyColor]) {
    return LEGACY_COLOR_TO_VARIANT[legacyColor]
  }
  return 'neutral'
}

const snackbarState = reactive({
  isVisible: false,
  variant: 'neutral',
  text: '',
  instanceKey: 0,
})

export const snackbarService = {
  state: snackbarState,

  show(info) {
    if (typeof info === 'string') {
      snackbarState.variant = 'error'
      snackbarState.text = info
    } else {
      snackbarState.variant = resolveVariant(info)
      snackbarState.text = info?.message || info?.text || ''
    }

    snackbarState.instanceKey += 1
    snackbarState.isVisible = true
  },

  close() {
    snackbarState.isVisible = false
  },
}
